import Footer from "../components/footer";
import Navbar from "../components/navbar";
import "../css/npors.css";

import { Helmet } from "react-helmet";

import agriculturalTractor from "../images/n601-agriculturaltractor.jpg";
import cableAvoidanceTools from "../images/n304-cableavoidancetools.jpeg";
import chainSaw from "../images/n602-chainsaw.jpg";
import crusher from "../images/n207-crusher.jpg";
import dozer from "../images/n215-dozer.png";
import excavator180 from "../images/n201-excavator180.jpg";
import excavator360 from "../images/n202-excavator360.jpg";
import excavatorMicro from "../images/n016-excavatormicro.jpg";
import excavatorAsACrane from "../images/n100-excavatorasacrane.jpg";
import forwardTippingDumper from "../images/n204-forwardtippingdumper.webp";
import forwardTippingMiniDumper from "../images/n139-forwardtippingmindumper.jpg";
import gritterAndSnowplough from "../images/n802-gritterandsnowplough.jpg";
import harnessAndFallArrest from "../images/n723-harnessandfallarrest.jpg";
import industrialCounterBalancedForklift from "../images/n001-industrialcounterbalancelifttruck.jpg";
import loadingShovel from "../images/n209-loadingshovel.jpg";
import logHandler from "../images/n106-loghandler.jpg";
import lorryLoader from "../images/n107-lorryloader.jpg";
import mewpBoom from "../images/n108-mewpboom.jpg";
import mewpScissor from "../images/n109-mewpscissor.jpg";
import marineKnuckleBoomCrane from "../images/n014-marineknuckleboomcrane.jpg";
import paver from "../images/n220-paver.jpg";
import plantLoaderSecurer from "../images/n120-plantloadersecurer.jpg";
import plantMachineryMarshall from "../images/n133-plantmachinerymarshall.jpg";
import plantMover from "../images/n132-plantmover.webp";
import quickHitchAwareness from "../images/n726-quickhitchawareness.jpg";
import rearTippingDumper from "../images/n205-reartippingdumper.webp";
import roadPlaner from "../images/n216-roadplaner.jpg";
import roadRoller from "../images/n214-roadroller.jpg";
import roadSweeper from "../images/n217-roadsweeper.jpg";
import safeWorkingAtNight from "../images/n404-safeworkingatnight.png";
import safetyAwareness from "../images/s001-safetyawareness.jpg";
import screener from "../images/n208-screener.webp";
import slingerSignaller from "../images/n402-slingersignaller.jpg";
import telescopicHandler from "../images/n010-telescopichandler.png";
import vehicleMarshall from "../images/n403-vehiclemarshall.jpg";

const nporsCategories = [
  {
    code: "N601",
    title: "Agricultural Tractor",
    image: agriculturalTractor,
    link: "/npors-agriculturaltractor",
  },
  {
    code: "N304",
    title: "Cable Avoidance Tools",
    image: cableAvoidanceTools,
    link: "/npors-cableavoidance",
  },
  {
    code: "N602",
    title: "Chain Saw",
    image: chainSaw,
    link: "/npors-chainsawoperation",
  },
  { code: "N207", title: "Crusher", image: crusher, link: "/npors-crusher" },
  { code: "N215", title: "Dozer", image: dozer, link: "/npors-dozer" },
  {
    code: "N201",
    title: "Excavator 180°",
    image: excavator180,
    link: "/npors-excavator180",
  },
  {
    code: "N202",
    title: "Excavator 360°",
    image: excavator360,
    link: "/npors-excavator360",
  },
  {
    code: "N100",
    title: "Excavator as a Crane",
    image: excavatorAsACrane,
    link: "/npors-excavatorcrane",
  },
  {
    code: "N016",
    title: "Excavator Micro",
    image: excavatorMicro,
    link: "/npors-excavatormicro",
  },
  {
    code: "N204",
    title: "Forward Tipping Dumper",
    image: forwardTippingDumper,
    link: "/npors-forwardtippingdumper",
  },
  {
    code: "N139",
    title: "Forward Tipping Mini Dumper",
    image: forwardTippingMiniDumper,
    link: "/npors-forwardtippingminidumper",
  },
  {
    code: "N802",
    title: "Gritter & Snowplough",
    image: gritterAndSnowplough,
    link: "/npors-grittersnowplough",
  },
  {
    code: "N723",
    title: "Harness and Fall Arrest",
    image: harnessAndFallArrest,
    link: "/npors-harnessandfallarrest",
  },
  {
    code: "N001",
    title: "Industrial Counterbalance Lift Truck",
    image: industrialCounterBalancedForklift,
    link: "/npors-industrialcounterbalancedforklift",
  },
  {
    code: "N209",
    title: "Loading Shovel",
    image: loadingShovel,
    link: "/npors-loadingshovel",
  },
  {
    code: "N106",
    title: "Log Handler",
    image: logHandler,
    link: "/npors-loghandler",
  },
  {
    code: "N107",
    title: "Lorry Loader",
    image: lorryLoader,
    link: "/npors-lorryloader",
  },
  {
    code: "N108",
    title: "MEWP Boom",
    image: mewpBoom,
    link: "/npors-mewpboom",
  },
  {
    code: "N109",
    title: "MEWP Scissor Lift",
    image: mewpScissor,
    link: "/npors-mewpscissor",
  },
  {
    code: "N014",
    title: "Marine Knuckle Boom Crane",
    image: marineKnuckleBoomCrane,
    link: "/npors-marineknuckleboom",
  },
  { code: "N220", title: "Paver", image: paver, link: "/npors-paver" },
  {
    code: "N120",
    title: "Plant Loader & Securer",
    image: plantLoaderSecurer,
    link: "/npors-plantloadersecurer",
  },
  {
    code: "N133",
    title: "Plant Machinery Marshall",
    image: plantMachineryMarshall,
    link: "/npors-plantmachinery",
  },
  {
    code: "N132",
    title: "Plant Mover",
    image: plantMover,
    link: "/npors-plantmover",
  },
  {
    code: "N726",
    title: "Quick Hitch Awareness",
    image: quickHitchAwareness,
    link: "/npors-quickhitchawareness",
  },
  {
    code: "N205",
    title: "Rear Tipping Dumper",
    image: rearTippingDumper,
    link: "/npors-reartippingdumper",
  },
  {
    code: "N216",
    title: "Road Planer",
    image: roadPlaner,
    link: "/npors-roadplaner",
  },
  {
    code: "N214",
    title: "Road Roller",
    image: roadRoller,
    link: "/npors-rideonroller",
  },
  {
    code: "N217",
    title: "Road Sweeper",
    image: roadSweeper,
    link: "/npors-roadsweeper",
  },
  {
    code: "N404",
    title: "Safe Working At Height",
    image: safeWorkingAtNight,
    link: "/npors-safeworkingatnight",
  },
  {
    code: "S001",
    title: "Safety Awareness",
    image: safetyAwareness,
    link: "/npors-safetyawareness",
  },
  { code: "N208", title: "Screener", image: screener, link: "/npors-screener" },
  {
    code: "N402",
    title: "Slinger / Signaller",
    image: slingerSignaller,
    link: "/npors-slingersignaller",
  },
  {
    code: "N010",
    title: "Telescopic Handler",
    image: telescopicHandler,
    link: "/npors-telescopichandler",
  },
  {
    code: "N403",
    title: "Vehicle Marshal",
    image: vehicleMarshall,
    link: "/npors-vehiclemarshall",
  },
];

export default function Npors() {
  return (
    <>
      <Helmet>
        <title>NPORS | Alpha Construction Training</title>
        <meta
          name="description"
          content="Discover NPORS certification at Alpha Construction Training. We offer training and assessments for cranes, earthmoving, handling, and demolition equipment in the UK."
        />
        <link rel="canonical" href="https://www.alphacontraining.co.uk/npors" />
      </Helmet>

      <Footer />
      <Navbar />

      <div className="npors-container">
        <header className="npors-header">
          <h2>NPORS Training & Assessments</h2>
        </header>

        <div className="npors-grid">
          {nporsCategories.map((item) => (
            <div
              key={item.code}
              className="npors-card"
              onClick={() => (window.location.href = item.link)}
            >
              <div className="image-wrapper">
                <img src={item.image} alt={item.title} />
              </div>

              <div className="card-content">
                <span className="category-code">{item.code}</span>
                <h3 className="category-title">{item.title}</h3>
                <div className="view-link">View Course Details →</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
